import moment from 'moment';
import i18n from './plugins/vue-i18n';
import VueRx from 'vue-rx';
import VuejsClipper from 'vuejs-clipper/dist/vuejs-clipper.umd.min';
import 'vuejs-clipper/dist/vuejs-clipper.css';
import VueYoutube from 'vue-youtube';

import Vue from 'vue';
import App from './App.vue';
// import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { api } from '@/api/index';
import VueRouter from 'vue-router';

import VueCurrencyFilter from 'vue-currency-filter';
import Toast from 'vue-toastification';

import 'vue-toastification/dist/index.css';
// override toast style
import './scss/toast.scss';

import './scss/main.scss';
import './scss/utils.scss';
import './scss/typography.scss';

// inject global components
import './GlobalComponentsInject.js';

import confirm from './plugins/confirm';
import rules from './plugins/rules';
import shrinkImg from './plugins/shrinkImg';
import './plugins/vuetify-mask.js';

function hms2s(str) {
  str = `${str}`;
  const p = str.split(':');
  let s = 0;
  let m = 1;

  while (p.length > 0) {
    s += m * parseInt(p.pop(), 10);
    m *= 60;
  }

  return s;
}

function s2hms(str) {
  if (!str) return '00:00:00';
  return new Date(str * 1000).toISOString().substr(11, 8);
}

Vue.use(VueCurrencyFilter, {
  symbol: '',
  thousandsSeparator: ',',
  fractionCount: 0,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true,
  avoidEmptyDecimals: undefined
});

Vue.use(VueYoutube);

// install vue-rx
Vue.use(VueRx);
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: true
  }
});

Vue.config.productionTip = false;
Vue.use(VueRouter);

Vue.directive('visible', (el, binding) => {
  binding.value
    ? (el.style.visibility = 'visible')
    : (el.style.visibility = 'hidden');
});

const toastOptions = {
  position: 'top-center',
  timeout: 2200
};

Vue.filter('formatTime', (v) => {
  return v && moment(v).format('YYYY/MM/DD hh:mm:ss');
});

Vue.use(Toast, toastOptions);

const inProduction = /https:\/\/panel.virsody.io/.test(window.location.origin);
const inStaging = /https:\/\/staging-panel.virsody.io/.test(
  window.location.origin
);

Vue.prototype.$inTestPage = !inProduction && !inStaging;
Vue.prototype.$inProduction = inProduction;
Vue.prototype.$inStaging = inStaging;

Vue.prototype.$shrinkImg = shrinkImg;
Vue.prototype.$hms2s = hms2s;
Vue.prototype.$s2hms = s2hms;
Vue.prototype.$api = api;
Vue.prototype.$confirm = confirm;
Vue.prototype.$rules = rules;
Vue.prototype.$moment = moment;
Vue.prototype.$frontPageURL = process.env.VUE_APP_FRONT_PAGE_URL;
Vue.prototype.$vsnovaPageURL = process.env.VUE_APP_TO_VSNOVA_URL;
const urlParams = new URLSearchParams(window.location.search);
if (
  ['verify', 'reset-password'].includes(urlParams.get('action')) ||
  urlParams.has('auth')
) {
  localStorage.removeItem('at');
  localStorage.removeItem('rt');
}

(async () => {
  // window.addEventListener('focus', store.dispatch('auth/CHECK_LOGIN_STATUS'));

  // const isLogin = await store.dispatch('auth/CHECK_LOGIN_STATUS');
  // if (isLogin) {
  //   await store.dispatch('auth/FETCH_TEAMS');
  // }

  Vue.prototype.$grants = store.getters['auth/getGrants'];
  Vue.prototype.$getGrantValue = store.getters['auth/getGrantValue'];

  const { routes } = require('./router/routes');
  const filteredRoutes = routes();

  const originalPush = VueRouter.prototype.push;
  VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
  };

  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [...filteredRoutes]
  });

  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App)
  }).$mount('#app');
})();
